// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__20hZl","empty":"ModalGraph_empty__1QvjC"};